import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpServiceBase } from '../classes/HttpServiceBase';

export interface AdminUserPayload {
    username: string;
    name?: string;
    mobile?: string;
    email?: string;
    active?: boolean;
    isAdmin?: boolean;
    /** Sales dashboard access without administration rights. */
    canAccessOrders?: boolean;
    categoryIds?: string[];
    /** Only sent when set/changed; hashed server-side. */
    password?: string;
}

/** Admin users CRUD (backend rest/fyes/admin/users). */
@Injectable({ providedIn: 'root' })
export class AdminUsersService extends HttpServiceBase {
    protected override baseUrl = '/admin/users';

    constructor(private http: HttpClient) {
        super();
        this.assign(this);
    }

    public list(): Observable<any> {
        return this._http.get(this.baseUrl)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public create(user: AdminUserPayload): Observable<any> {
        return this._http.post(this.baseUrl, user)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public update(id: string, user: AdminUserPayload): Observable<any> {
        return this._http.put(`${this.baseUrl}/${id}`, user)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public delete(id: string): Observable<any> {
        return this._http.delete(`${this.baseUrl}/${id}`)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }
}
